export enum ExternalURLs {
  LinkedInPage = 'https://www.linkedin.com/company/the-xp-lab/',
  DiscordInvite = 'https://discord.gg/aWTWHDqQW4',
  DiscordInviteIntoBugReportChannel = 'https://discord.com/channels/1455148484746416140/1458496864298209444',
}

export enum ExternalAssets {
  WorkspaceScreenshotDark = 'https://www.xp-lab.com/public/app-media/workspace-d1.png',
  WorkspaceScreenshotLight = 'https://www.xp-lab.com/public/app-media/workspace-l1.png',
  SiteOGImage = 'https://www.xp-lab.com/public/app-media/og-image.jpg',
  AchievementOGImage = 'https://www.xp-lab.com/public/app-media/og-image-achievement.png',
  FounderBen = 'https://www.xp-lab.com/public/app-media/team-ben-haran.jpg',
  FounderTal = 'https://www.xp-lab.com/public/app-media/team-tal-mizrachi.png',
  ChallengesAvailableOGImage = 'https://www.xp-lab.com/public/app-media/og-available-challenges.png',
}